var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choice_container"},[_c('el-tag',{staticClass:"tag",attrs:{"value":_vm.value,"size":"medium","type":_vm.check? undefined : 'info',"effect":_vm.check? 'light' : 'plain'},on:{"click":function($event){return _vm.checkTag(_vm.value)}}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }